import { render } from "./TriangleImages.vue?vue&type=template&id=24c6143e&scoped=true&ts=true"
import script from "./TriangleImages.vue?vue&type=script&lang=ts"
export * from "./TriangleImages.vue?vue&type=script&lang=ts"

import "./TriangleImages.vue?vue&type=style&index=0&id=24c6143e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c6143e"]])

export default __exports__